import template from "bundle-text:./index.html";

export const Sidenav = () => {
  return template;
};
